import { EMPTY_VALUE, SECONDS_PER_HOUR } from '../../constants';
import { healthTabMocks } from '../../mockData';
import useTranslation from '../useTranslation';
import { formatDistanceToNowStrict } from 'date-fns';
import { formatToUSDate } from 'utils/dateTimeUtils/dateFormatUtil';

import type { MetricRow, Props, UseData } from './types';

const useData = ({ drone }: Props): UseData => {
    const labels = useTranslation();

    const flightHours = `${Math.round(drone.flightSeconds / SECONDS_PER_HOUR)} h`;

    const warrantyStart = drone.warranty
        ? formatToUSDate(new Date(drone.warranty.start))
        : EMPTY_VALUE;
    const warrantyEnd = drone.warranty ? formatToUSDate(new Date(drone.warranty.end)) : EMPTY_VALUE;

    const getWarrantyRemaining = (): string => {
        if (!drone.warranty) {
            return EMPTY_VALUE;
        }

        const end = new Date(drone.warranty.end);

        return end.getTime() <= Date.now() ? labels.EXPIRED : formatDistanceToNowStrict(end);
    };

    const metrics: MetricRow[] = [
        { label: labels.TOTAL_FLIGHT_HOURS, value: flightHours },
        { label: labels.BATTERY_CYCLES, value: healthTabMocks.batteryCycles },
        { label: labels.LAST_PUMP_CALIBRATION, value: healthTabMocks.pumpCalibration },
        { label: labels.LAST_WEIGHT_CALIBRATION, value: healthTabMocks.weightCalibration },
        {
            label: labels.LAST_MAGNETOMETER_CALIBRATION,
            value: healthTabMocks.magnetometerCalibration
        },
        { label: labels.LAST_LEVEL_CALIBRATION, value: healthTabMocks.levelCalibration },
        { label: labels.FAA_REGISTRATION, value: drone.faaRegistrationNumber ?? EMPTY_VALUE },
        {
            label: labels.DRONE_SERIAL_NUMBER,
            value: drone.flightControllerSerialNumber ?? EMPTY_VALUE
        },
        { label: labels.FIRMWARE, value: drone.flightControllerFirmwareVersion },
        { label: labels.WARRANTY_START, value: warrantyStart },
        { label: labels.WARRANTY_END, value: warrantyEnd },
        { label: labels.WARRANTY_REMAINING, value: getWarrantyRemaining() }
    ];

    return { metrics };
};

export default useData;
